import React, {Component} from "react";
import {Row, Col, Modal} from "reactstrap";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {AnimatedTree} from "react-tree-graph";
import "assets/css/fjtree.css"
import {graphModalRequest} from "../../store/components/graphModal/actions";

class GraphModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      graphData: {name: this.props.title},
      count: 0,
      loading: false,
      error: ""
    }
  }

  componentDidMount() {
    this.props.onGraphModalRequest({call: this.props.call, data: {...this.props.actionData, history: this.props.history}})
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        graphData: this.props.response ? this.props.response.response.graph : {name: this.props.title},
        count: this.props.response ? this.props.response.response.count : 0,
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  onClose = () => {
    this.props.togModal()
  }

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={true} toggle={this.onClose} size="xl">
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              {this.props.title}
            </h5>
            <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col lg="12" className="mb-1">
                {!this.state.loading && <div className="fjtree-container">
                  <AnimatedTree data={this.state.graphData} height={50 + (this.state.count * 25)} width={1050} svgProps={{className: 'fjtree'}} labelProp={"label"}/>
                </div>}
                {this.state.loading && <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>}
              </Col>
            </Row>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

GraphModal.propTypes = {
  response: PropTypes.any,
  onGraphModalRequest: PropTypes.func,
};

const mapStateToProps = ({GraphModal}) => ({
  response: GraphModal.response,
  loading: GraphModal.loading,
  error: GraphModal.error,
});

const mapDispatchToProps = dispatch => ({
  onGraphModalRequest: data => dispatch(graphModalRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GraphModal));
